import miningSelect from '@/assets/images/cards/miningSelect.png'
import bg from "@/assets/images/talk/bg.png"
import { useCallback, useEffect, useRef, useState } from 'react'
import coin from '@/assets/images/coin.png'
import transparent from '@/assets/images/transparent.png'
import des from '@/assets/images/cards/des.png'
import asc from '@/assets/images/cards/asc.png'
import sortIcon from '@/assets/images/cards/sort.png'
import power_bg from '@/assets/images/attribute/power_bg.png'
import newNfted from '@/assets/images/newNfted.png'
import water from '@/assets/images/attribute/water.png'
import electric from '@/assets/images/attribute/electric.png'
import grass from '@/assets/images/attribute/grass.png'
import ground from '@/assets/images/attribute/ground.png'
import fire from '@/assets/images/attribute/fire.png'
import nftImg from "@/assets/images/newNfted.png"
import { useNavigate, useSearchParams } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux';
import { pushChatListId, setCurrCharacterInfo, setCurrAvatarId, removeAvatarsImgList, changeAvatarAudio, popAvatarsChatList } from '../../store/module/progress';
import { getCharactersList, getAnnouncement, postSetting, getUserInfo, getSetting, deleteAvatarRequest, getAvatarCommercial, postAvatarCommercial, checkAvatar, getLanguageList, logsListApi } from '@/api/url.js'
import BScroll from 'better-scroll'
import { getHeroCard } from "@/api/character.js"
import { changeCharacterList, changeUserInfo } from '../../store/module/tabbar';
import { languageListHandle } from "../../store/module/createAvatar"
import Message from '../../components/message/Message';
import { getAnnouncementList } from "../../store/module/search"
import PromptDialog from '../../components/PromptDialog';
import { changeSettings } from '../../store/module/settins';
import closeMusic from "../../assets/mp3/close.mp3"
import Back from '../../components/common/BackComp';
import ButtonComp from '../../components/common/ButtonComp';
import { Swiper, Image, List, Loading, Popover, PopoverInstance, Toast } from 'react-vant';
import loading from '@/assets/images/cards/loading.png'
import { attributeImage, FormattingNumber } from '../../utils';
import like from "@/assets/images/like.png"
import Chars from "@/components/Chat.tsx"
import ShareLog from '../talk/ShareLog';
import show from '@/assets/images/cards/show.svg'
import Logs from "./Logs"
import Init from '../../layout/Init';
import { postWarningInformation } from "@/api/url.js"
import NsfwPay from '../../components/nsfw/nsfwPay'

import GlassmorphismCanvas from '../../hook/useBlur'
import { changeLoginState } from '../../store/module/h5Login'
import { useTranslation } from "react-i18next";
import AgentsGuide from '../../components/guide/AgentsGuide'
BScroll('.role-box', {
    pullUpLoad: true,
    scrollbar: true,
    pullDownRefresh: true
    // and so on
})

interface CharacterProps {
    type?: string
    callback?: Function
    cardArray?: Array<any>
    isNft?: boolean
}
const Character = ({ type, callback, cardArray, isNft }: CharacterProps) => {

    const { t } = useTranslation()
    const pageSize = 10
    const guideType = useSelector((state: any) => state.tabbar.guideType)
    const userInfo = useSelector((state: any) => state.tabbar.userInfo)
    const [searchParams] = useSearchParams()
    const closeAudioRef = useRef<any>(null)
    const [text, setText] = useState<any>('')
    const [promptText, setPromptText] = useState<any>('')
    const [dialog, setDialog] = useState(false)
    const roleRef = useRef<any>(null);
    const popover = useRef<PopoverInstance>(null)
    const address_params = localStorage.getItem('address_params')
    const guideTypeList = useSelector((state: any) => state.progress.guideTypeList)
    const chatMessageList = useSelector((state: any) => state.progress.chatList)
    const announcementList = useSelector((state: any) => state.search.announcementList)
    const { settings, isShowIntroductory } = useSelector((state: any) => state.settings)
    const [coin_NSFW, setCoin_NSFW] = useState(false)
    const [isActive, setActive] = useState<any>((type == 'mining' ? 3 : searchParams.get("id") ? Number(searchParams.get("id")) : sessionStorage.getItem('avatarListId')) || 1)
    const [finished, setFinished] = useState(false);
    const isInitLoading = useRef(true)
    const [isLoading, setIsLoading] = useState(false)
    const [delDialog, setDelDialog] = useState(false)
    const [payDialog, setPayDialog] = useState(false)
    const [isFirst, setIsFirst] = useState(false)
    const currPage = useRef(1)
    const total = useRef(0);
    const logsTotal = useRef(0)
    const [ids, setIds] = useState<any>([])
    const [spendCoins, setSpendCoins] = useState(false)
    const [isClickTag, setClickTag] = useState(false)
    const [starType, setStateType] = useState<any>("")
    const navList = [
        {
            name: t("ai.hot"),
            id: 1,
        },
        {
            name: t("ai.new"),
            id: 2,
        },
        {
            name: t("ai.mine"),
            id: 3,
        },
        // {
        //     name: "Logs",
        //     id: 4
        // }
    ]
    const [sort, setSort] = useState<any>(0)
    function coinIsNSFW() {
        try {
            postSetting(localStorage.getItem('userId'), { ...settings, ...starType }).then((result: any) => {
                if (result.code == 0) {
                    dispatch(changeSettings({ ...settings, ...starType }))
                    setUserInfo()
                } else if (result.code == '65547') {
                    setText(t("other.attention"))
                    setPromptText(t("talk.insuf"))
                    setDialog(true)
                }
            })
        } catch {
            setText(t("other.attention"))
            setPromptText(t("other.neterror"))
            setDialog(true)
        }
    }
    function attributeImage(attribute: string) {
        switch (attribute) {
            case 'water':
                return water
            case 'electric':
                return electric
            case 'grass':
                return grass
            case 'ground':
                return ground
            case 'fire':
                return fire
            default:
        }
    }

    const setUserInfo = useCallback(async () => {
        const UserInfo = await getUserInfo(localStorage.getItem('address_params'))
        if (UserInfo.code == "0") {
            dispatch(changeUserInfo(UserInfo.data))
        }
        try {
            const { code, data: { languages } } = await getLanguageList()
            if (code == '0') {
                dispatch(languageListHandle(languages))
            }
        } catch (e) {
            console.log("🚀 ~ getLanguage error ~ e:", e)

        }

    }, [])

    useEffect(() => {
        setUserInfo()
    }, [])
    const dispatch = useDispatch()
    const initCharacterList = useSelector((state: any) => state.tabbar.characterList)
    //从缓存中拉取数字人列表数据
    const [characterList, setCharacterList] = useState(initCharacterList)

    if (window.localStorage.getItem("currCharacterInfo") == "undefined") {
        window.localStorage.removeItem("currCharacterInfo")
    }

    const characterInfo: any = window.localStorage.getItem("currCharacterInfo") && JSON.parse(window.localStorage.getItem("currCharacterInfo")!) || null;
    const [_characterList, _setCharacterList] = useState(characterList);
    const [shareLogs, setShareLogs] = useState<any>([])
    const [avatarID, setAvatarID] = useState("")
    const [sessionID, setSessionID] = useState("")


    const getAnnouncements = useCallback(async () => {
        const { code, data: { announcement } } = await getAnnouncement()
        if (code == 0) {
            if (announcement.length > 0) {
                dispatch(getAnnouncementList(announcement))
            }

        }
    }, [])


    useEffect(() => {
        window.localStorage.setItem("isFromTalkPage", "no");
        if (characterInfo) {
            _setCharacterList((prevItems: any) => Array.isArray(prevItems) && prevItems.map((item: any) => item.id === characterInfo.id ? characterInfo : item))
        }
    }, [])
    const setCharacter = async () => {
        try {
            let params: any = {
                type: isActive ? isActive : '1',
                limit: pageSize,
                page: currPage.current,
                query: ""
            }
            setIsLoading(true)
            let code: any = ''
            let data: any = null

            if (type == 'mining') {
                if (isNft) {
                    params = {
                        ...params,
                        nft: true,
                    }
                }
                params.sortType = sort
                delete params.type
                const res = await getHeroCard(params)
                code = res.code
                data = res.data
            } else {
                const res = await getCharactersList(params)
                code = res.code
                data = res.data
            }


            if (code == 0) {
                setIsLoading(false)
                total.current = data.count
                isInitLoading.current = false
                // setFinished(true)
                setFinished(false)
                if (type == 'mining') {
                    setCharacterList((prevData: any) => [...prevData, ...data.cards]);
                } else {
                    setCharacterList((prevData: any) => [...prevData, ...data.list]);
                }
                window.localStorage.setItem("characterList", JSON.stringify(characterList))
                dispatch(changeCharacterList(characterList))

                if (data?.list?.length == 0 || data?.cards?.length == 0) {
                    setFinished(true)
                }

            } else {
                setFinished(true)
                total.current = 0
            }


        } catch (e) {
            setFinished(true)
            setIsLoading(false)
            total.current = 0
        }
        if (currPage.current * pageSize >= total.current) {
            setFinished(true)
            return false;
        }

    }
    //get logs
    const [LogsTotal, setLogsTotal] = useState(0)
    const getLogsList = async () => {
        logsTotal.current = 0
        const params = {
            limit: 1,
            page: currPage.current,
            query: ""
        }
        const { code, data } = await logsListApi(params)
        if (code == 0) {
            logsTotal.current = data.count
            setLogsTotal(logsTotal.current)
        } else {
            logsTotal.current = 0
            setLogsTotal(0)
        }
    }
    useEffect(() => {

        isInitLoading.current = true;
        setFinished(true)
        if (initCharacterList.length > 0 && isActive == 1) {
            currPage.current = 2
        } else {
            currPage.current = 1
            setCharacterList([])
        }


        setShareLogs([])
        if (isActive != 4) {
            setCharacter();
        } else {
            getLogsList()
        }
        upUserInfo()
    }, [isActive, isClickTag])

    const onLoad = async () => {
        if (finished || isInitLoading.current) return;
        currPage.current++
        if (isActive != 4) {
            await setCharacter();
        }

    }

    useEffect(() => {
        // getLogsList()
    }, [])
    const navigate = useNavigate();
    useEffect(() => {
        const ids = characterList.length && characterList.map((item: any) => item.id)
        setIds(ids)
        const listId = chatMessageList.map((item: any) => item.id)
        for (let i = 0; i < ids.length; i++) {
            if (!listId.includes(ids[i])) {
                dispatch(pushChatListId({ id: ids[i], list: [], actionList: [] }))
            }
        }

    }, [characterList])


    const [payData, setPayData] = useState<any>(null)

    const goToTalk = async (currCharacterInfo: any) => {
        setPayData(currCharacterInfo)
        if (currCharacterInfo.is_my) {
            await goToTalkPage(currCharacterInfo)

        } else {
            if (currCharacterInfo.avatar_type == 2) {
                if (!localStorage.getItem('token')) {
                    dispatch(changeLoginState(true))
                    return
                }
                try {
                    const { data, code } = await getAvatarCommercial(currCharacterInfo.id)
                    if (code == '0') {
                        if (data.ok) {
                            if (currCharacterInfo.is_nsfw) {
                                await nsfwHandle(currCharacterInfo)
                            } else {
                                await goToTalkPage(currCharacterInfo)
                            }
                        } else {
                            setPayDialog(true)
                        }
                    } else {
                        if (currCharacterInfo.is_nsfw) {
                            await nsfwHandle(currCharacterInfo)
                        } else {
                            await goToTalkPage(currCharacterInfo)
                        }

                    }
                } catch (e) {
                    if (currCharacterInfo.is_nsfw) {
                        await nsfwHandle(currCharacterInfo)
                    } else {
                        await goToTalkPage(currCharacterInfo)
                    }
                }
            } else {
                if (currCharacterInfo.is_nsfw) {
                    if (!localStorage.getItem('token')) {
                        dispatch(changeLoginState(true))
                        return
                    }
                    await nsfwHandle(currCharacterInfo)
                } else {
                    await goToTalkPage(currCharacterInfo)
                }
            }
        }
    }
    //go to talk page logic handler
    const goToTalkPage = async (currCharacterInfo: any) => {
        if (!chatMessageList.length) {
            for (let i = 0; i < ids.length; i++) {
                dispatch(pushChatListId({ id: ids[i], list: [], actionList: [] }))
            }
        }
        //缓存
        dispatch(setCurrCharacterInfo(currCharacterInfo))
        window.localStorage.setItem("currCharacterInfo", JSON.stringify(currCharacterInfo));
        dispatch(setCurrAvatarId(currCharacterInfo.id))
        //跳转到聊天页
        setTimeout(() => {
            navigate(`/agent/${currCharacterInfo.link}`);
        }, 200);

    }

    //run nsfw logic handler
    const nsfwHandle = async (currCharacterInfo: any) => {
        try {
            let ID = window.localStorage.getItem("userId") || "";

            const { code, data } = await getSetting(ID)
            // console.log(res)
            if (code == 0) {
                if (data.character_nsfw) {
                    await goToTalkPage(currCharacterInfo)
                } else {
                    setStateType({ character_nsfw: true })
                    setCoin_NSFW(true)
                }
            }
        } catch (e) {
            console.log(e)
        }

    }



    useEffect(() => {
        window.addEventListener("resize", resizeHandle)
        return () => {
            window.removeEventListener("resize", resizeHandle)
        }
    }, [])
    const resizeHandle = () => {
        const dom: any = document.querySelectorAll(".role")
        for (let i = 0; i < dom.length; i++) {
            const width = dom[i].clientWidth;
            dom[i].style.height = width / 2 * 3 + 'px'
        }
    }

    //create avatars
    const createAvatarsHandle = async () => {
        dispatch(popAvatarsChatList("remove"))
        dispatch(removeAvatarsImgList())
        dispatch(changeAvatarAudio(""));
        setSpendCoins(true)


    }

    const upUserInfo = async () => {
        const UserInfo = await getUserInfo(address_params)
        dispatch(changeUserInfo(UserInfo.data))
    }


    const createHandle = async () => {
        const res = await checkAvatar()

        if (res.code == "0") {
            navigate("/create-agents")
        } else if (res.code == "65547") {
            setText(t("other.attention"))
            setPromptText(t("talk.neterror"))
            setDialog(true)
        }
    }
    const [deleteId, setDeleteId] = useState('')
    const deleteAvatar = async () => {
        try {
            const { code } = await deleteAvatarRequest(deleteId)
            if (code == '0') {
                currPage.current = 1
                setCharacterList([])
                setCharacter();
            } else if (code == "65541") {
                setText(t("other.attention"))
                setPromptText(t("agent.agent.ai_agent_in_deck"))
                setDialog(true)
            } else {
                currPage.current = 1
                setCharacterList([])
                setCharacter();
            }
        } catch (e) {
            currPage.current = 1
            setCharacterList([])
            setCharacter();
        }

    }

    const postCommercial = async () => {
        try {
            const { data, code, msg } = await postAvatarCommercial(payData.id)
            if (code == '0') {
                await goToTalkPage(payData)
            } else {
                setPayDialog(false)
                setText(t("other.attention"))
                setDialog(true)
                setPromptText(msg)
            }
        } catch {
            setPayDialog(false)
        }

    }
    useEffect(() => {
        if (type === 'mining' && isFirst) {
            setCharacterList([])
            setCharacter()
        }
        setIsFirst(true)
    }, [sort])
    const characterDom = useRef<any>(null)
    const swiperRef = useRef<any>(null)
    return (
        <div ref={characterDom} className={`role-box descriptionLogs w-full !h-[calc(100%_-_125px)] text-white pt-[100px] px-4 box-border flex flex-wrap relative justify-between items-start ${type !== 'mining' ? isActive != 4 ? 'pb-[32px]' : 'pb-[0px]' : 'pb-[32px]'}`}>
            {type !== 'mining' ?
                <div className="h-[36px] flex items-center justify-center fixed top-[52px] rounded-[10px] max-md:w-[calc(100vw_-_32px)] md:w-[343px] lg:w-[408px]  xl:w-[468px] z-[20] box-border bg-[#32726E]">
                    <div className='w-[100%] h-[36px]  text-white flex items-center'>
                        {
                            navList.map(item => {
                                return (
                                    <div onClick={() => {
                                        if (!isLoading) {
                                            total.current = 0
                                            setFinished(false)
                                            setActive(item.id)
                                            setClickTag(!isClickTag)
                                            sessionStorage.setItem('avatarListId', item.id.toString())
                                            window.localStorage.setItem("characterList", JSON.stringify([]))
                                            dispatch(changeCharacterList([]))
                                        }
                                    }} key={item.id} className={`${item.id == isActive ? 'bg-gradient-to-r from-[#00E49F] to-[#54ADFF] !w-[80px]' : ''} text-[#A6A6A6] h-[36px] flex w-[80px] justify-center overflow-auto items-center py-1 rounded-[10px] relative`}>

                                        <span className={`${item.id == isActive ? 'text-white' : ' '} flex items-center`}>
                                            {item.name}&nbsp;&nbsp;
                                            {!isLoading && item.id == isActive && <span className='text-white'>
                                                {FormattingNumber(isActive != 4 ? total.current.toString() : LogsTotal.toString())}
                                            </span>}
                                            <>
                                                {item.id == isActive && isLoading &&
                                                    <svg className={`ml-[6px]  animate-spin `} width="12px" height="12px" viewBox="0 0 12 12" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
                                                        <defs>
                                                            <linearGradient x1="-2.72351586e-14%" y1="-1.94289029e-13%" x2="100%" y2="100%" id="linearGradient-1">
                                                                <stop stopColor={'#fff'} offset="0%"></stop>
                                                                <stop stopColor={'#fff'} offset="100%"></stop>
                                                            </linearGradient>
                                                        </defs>
                                                        <g id="页面-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                                                            <g id="10-cards-sale" transform="translate(-279.000000, -60.000000)" fill="url(#linearGradient-1)" fillRule="nonzero">
                                                                <g id="编组" transform="translate(279.000000, 60.000000)">
                                                                    <path d="M11.7148409,2.30618042 C11.4911427,2.21958428 11.2443829,2.34576723 11.1659732,2.58576224 L10.8338852,3.58532915 C10.444143,2.64266829 9.8283965,1.8138195 9.04429979,1.19280144 C6.55133349,-0.786538945 2.99983662,-0.247168689 1.13184152,2.40019909 C0.227824132,3.68182199 -0.154999551,5.26034596 0.0571677919,6.84381828 C0.269335135,8.43471312 1.05573801,9.84251898 2.26647558,10.8049732 C3.28118897,11.6090803 4.46886487,12 5.6473161,12 C7.3700227,12 9.06966762,11.1711512 10.1789338,9.60004977 C10.6701474,8.90480646 11.0045416,8.12791535 11.1775041,7.28669569 C11.2282397,7.03680397 11.0806451,6.7918606 10.8500284,6.73742873 C10.6194117,6.68299687 10.388795,6.83886993 10.3380593,7.08876165 C10.1927708,7.79885002 9.90911231,8.4569807 9.4940023,9.04336029 C7.90966572,11.2874375 4.89550572,11.7451599 2.7784446,10.0627206 C1.75220038,9.24871686 1.08802434,8.05863844 0.908143328,6.71268697 C0.728262313,5.37415803 1.05112567,4.04057745 1.81677305,2.95688857 C3.39880347,0.712811404 6.41065731,0.252614756 8.53002459,1.93505409 C9.29797813,2.54370126 9.87221366,3.38739511 10.1835462,4.33995266 L8.70529326,3.72140878 C8.48390124,3.62986429 8.23483523,3.74615054 8.14720089,3.98367139 C8.05956655,4.22119224 8.17026256,4.4884032 8.39165457,4.58242186 L10.568676,5.49539262 C10.6194117,5.5176602 10.6724535,5.5275569 10.7254954,5.5275569 C10.7324139,5.5275569 10.7393324,5.52508272 10.7462509,5.52508272 C10.762394,5.5275569 10.7785372,5.53497942 10.7946804,5.53497942 C10.9722552,5.53497942 11.1382992,5.416219 11.2005657,5.22818165 L11.9754378,2.90245669 C12.0538474,2.65751334 11.9385391,2.39277656 11.7148409,2.30618042 Z" id="路径"></path>
                                                                </g>
                                                            </g>
                                                        </g>
                                                    </svg>}
                                            </>
                                        </span>
                                    </div>
                                )
                            })
                        }
                        <div className={`search ml-[12px] flex-1 h-[36px] flex items-center justify-around`} >
                            <svg onClick={() => {
                                if (!isLoading) {
                                    total.current = 0
                                    setFinished(false)
                                    setActive('4')
                                    setClickTag(!isClickTag)
                                    sessionStorage.setItem('avatarListId', '4')
                                    window.localStorage.setItem("characterList", JSON.stringify([]))
                                    dispatch(changeCharacterList([]))
                                }
                            }} width="22px" height="22px" viewBox="0 0 22 22" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">

                                <g id="页面-2" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                                    <g id="人物聊天三个按钮展开" transform="translate(-337.000000, -140.000000)" fillRule="nonzero">
                                        <g id="编组-4" transform="translate(337.000000, 140.000000)">
                                            <rect id="矩形" fill="#000000" opacity="0" x="0" y="0" width="22" height="22"></rect>
                                            <g id="编组备份-4" transform="translate(3.000000, 3.000000)" fill="#FFFFFF">
                                                <path d="M8.89787636,13.0758761 C8.87282756,13.2493384 8.93314862,13.4241451 9.06086812,13.548216 L9.06588172,13.5520887 C9.17688812,13.664329 9.33035062,13.7279419 9.49087552,13.7282561 C9.67586403,13.7282561 9.83385879,13.6411607 9.94286306,13.514342 L15.8287781,7.29438001 C15.9475705,7.17963984 16.0095188,7.02091381 15.9987757,6.85880655 C16.0096505,6.69668024 15.9476823,6.53790328 15.8287781,6.42323309 L9.90985964,0.168432906 C9.67402822,-0.0561443019 9.29570346,-0.0561443019 9.05987204,0.168432906 C8.9327792,0.292847378 8.87287999,0.467504802 8.89787636,0.640788911 L8.89787636,4.00921189 C3.98395197,4.00921189 0,7.84804649 0,12.5851208 C-0.000338104389,13.7605372 0.250942241,14.9232713 0.737995432,16 C1.43999886,12.4283169 4.97793942,9.7151985 8.88788236,9.7151985 L8.89787636,13.0758761 Z" id="路径"></path>
                                            </g>
                                        </g>
                                    </g>
                                </g>
                            </svg>
                            <svg
                                className='mx-4  cursor-pointer'
                                onClick={() => { navigate("/search-agents") }}
                                width="18px" height="18px" viewBox="0 0 18 18" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">

                                <g id="页面-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                                    <g id="10-cards-sale" transform="translate(-341.000000, -56.000000)" fill="#FFFFFF" fillRule="nonzero">
                                        <g id="编组" transform="translate(341.000000, 56.000000)">
                                            <path d="M17.7932931,16.780932 L14.4487269,13.4363657 C15.6420385,12.0147435 16.3617488,10.1821212 16.3617488,8.18082326 C16.3617488,3.66268725 12.6990615,0 8.18092555,0 C3.66268725,0 0,3.66258496 0,8.18072097 C0,12.698857 3.66268725,16.3615442 8.18082326,16.3615442 C10.1821212,16.3615442 12.0147435,15.6419362 13.4363657,14.4486246 L16.780932,17.7931908 C17.0609287,18.0699859 17.5119001,18.0687007 17.7903146,17.7903143 C18.0687292,17.5119279 18.0700599,17.0609566 17.7932931,16.780932 L17.7932931,16.780932 Z M1.43164663,8.18072097 C1.43164663,4.45921714 4.45931943,1.43154434 8.18082326,1.43154434 C11.9023271,1.43154434 14.9299999,4.45921714 14.9299999,8.18072097 C14.9299999,11.9022248 11.9023271,14.9298976 8.18082326,14.9298976 C4.45931943,14.9298976 1.43164663,11.9022248 1.43164663,8.18072097 Z" id="形状"></path>
                                        </g>
                                    </g>
                                </g>
                            </svg>
                            <svg
                                className='cursor-pointer'
                                onClick={() => { navigate("/agents-records") }}
                                width="18px" height="18px" viewBox="0 0 12 12" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">

                                <g id="页面-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                                    <g id="02-talk平铺" transform="translate(-64.000000, -255.000000)" fill="#fff" fillRule="nonzero">
                                        <g id="编组-12" transform="translate(16.000000, 213.000000)">
                                            <g id="编组-11" transform="translate(10.000000, 41.000000)">
                                                <g id="编组备份-13" transform="translate(38.000000, 1.000000)">
                                                    <path d="M11.5239457,3.42134657 C11.2161611,2.7466612 10.7767079,2.1399395 10.2312596,1.63662729 C9.68247157,1.12220127 9.04171997,0.715207345 8.34233458,0.436816014 C6.84395033,-0.145605338 5.18103645,-0.145605338 3.6826522,0.436816014 C2.97615232,0.712982518 2.32842877,1.12008551 1.77368555,1.63662729 C1.23594722,2.14222152 0.803473534,2.74870995 0.501041122,3.42134657 C0.178294404,4.10860716 0.00741922747,4.85707272 0,5.61600137 C0.00821477146,6.99708519 0.546071031,8.32262114 1.50312335,9.3204187 L1.77368555,11.6250562 C1.79898275,11.8381332 1.97951517,11.9989627 2.19456009,12 C2.26829417,12.0001518 2.34080535,11.9812032 2.40499735,11.9450059 L4.14862044,10.9451631 C5.52973447,11.3649235 7.01226158,11.3085725 8.35736582,10.7851883 C9.06386569,10.5090218 9.71158924,10.1019188 10.2663325,9.58537702 C10.7970641,9.08283239 11.2242718,8.48166296 11.5239457,7.81565538 C12.1586848,6.41934278 12.1586848,4.81765917 11.5239457,3.42134657 Z M3.40707958,6.27089836 C3.05011418,6.27089836 2.76073656,5.98216743 2.76073656,5.62599979 C2.76073656,5.26983215 3.0501142,4.98110124 3.4070796,4.98110124 C3.764045,4.98110124 4.0534227,5.26983216 4.0534227,5.6259998 C4.05359058,5.97450211 3.77623622,6.26009212 3.42712123,6.27089836 L3.40707958,6.27089836 Z M5.99245174,6.27089836 C5.63548634,6.27089836 5.34610872,5.98216743 5.34610872,5.62599979 C5.34610872,5.26983215 5.63548636,4.98110124 5.99245176,4.98110124 C6.34941716,4.98110124 6.63879486,5.26983216 6.63879486,5.6259998 C6.63896274,5.97450211 6.36160838,6.26009212 6.01249339,6.27089836 L5.99245174,6.27089836 Z M8.5778239,6.27089836 C8.2208585,6.27089836 7.93148088,5.98216743 7.93148088,5.62599979 C7.93148088,5.26983215 8.22085852,4.98110124 8.57782391,4.98110124 C8.93478931,4.98110124 9.22416697,5.26983216 9.22416697,5.6259998 C9.22426192,5.97639176 8.94393696,6.26274972 8.59285513,6.27089836 L8.5778239,6.27089836 Z" id="形状"></path>
                                                </g>
                                            </g>
                                        </g>
                                    </g>
                                </g>
                            </svg>
                        </div>

                    </div>

                </div>

                :
                <Back position={true} title={isNft ? t("agent.agent.select_nfts") : t("agent.agent.select_agents")} callback={() => { callback && callback() }}></Back>
            }
            <>
                {type == 'mining' && <div className='bg-[#123a38] flex h-[30px] w-[calc(100vw_-_32px)] z-[100] left-4 top-[44px] rounded-[10px] fixed'>
                    <div onClick={async () => {
                        let index = sort === 0 ? 1 : sort === 1 ? 2 : 1
                        currPage.current = 1
                        total.current = 0
                        setSort(index)
                    }} className={`${sort == 1 || sort == 2 ? '!bg-[#32726E] text-[#FFF] ' : 'text-[#a6a6a6] '} rounded-[10px] w-[50%] px-5 py-2 leading-[15px] flex text-[12px] justify-between items-center`}>
                        {t("agent.agent.power")}
                        <div>
                            <img className={`w-[9px] h-[12px]`} src={sort == 1 ? des : sort == 2 ? asc : sortIcon} alt="" />
                        </div>
                    </div>
                    <div onClick={async () => {
                        let index = sort === 0 ? 3 : sort === 3 ? 4 : 3
                        currPage.current = 1
                        total.current = 0
                        setSort(index)
                    }} className={`${sort == 3 || sort == 4 ? '!bg-[#32726E] text-[#FFF] ' : 'text-[#a6a6a6] '} rounded-[10px] w-[50%] px-5 py-2 leading-[15px] flex text-[12px] justify-between items-center`}>
                        {t("agent.agent.time")}
                        <div>
                            <img className={`w-[9px] h-[12px]`} src={sort == 3 ? des : sort == 4 ? asc : sortIcon} alt="" />
                        </div>
                    </div>
                </div>}
            </>
            {/* <Message list={announcementList}></Message> */}
            <div className={`md:h-[100%] w-[100%] ${type !== 'mining' ? isActive != 4 ? 'md:pb-[147px]' : 'md:pb-[120px]' : 'md:pb-[32px]'} pt-[10px] md:pb-[117px] md:overflow-y-auto`}>
                {isActive != 4 &&
                    <List className={`list w-full ${isNft ? "" : ''} flex flex-wrap  justify-between`} finished={finished} loading={isLoading} immediateCheck={false} onLoad={onLoad} loadingText="Loading...">
                        {characterList.length > 0 && characterList?.map((item: any, i: number) => {
                            return (
                                <div ref={roleRef} key={`characterList ${item.id}`} className={`role min-h-[269px] w-[calc((100%_-_5px)/2)] rounded-xl mb-[5px] relative overflow-hidden  bg-cover bg-center ${(characterList.length % 2 != 0 && i == characterList.length - 1) ? 'mr-auto' : ''}`}>
                                    {
                                        <img className='w-[23px] z-[2] h-[23px] absolute top-0 left-0' src={attributeImage(item.property)}></img>
                                    }
                                    {
                                        item.mint_state == 3 && <img className='w-[42px] z-[2] h-[20px] absolute top-[30px] left-[0px]' src={nftImg}></img>
                                    }
                                    {isActive === 3 && type !== 'mining' &&
                                        <>
                                            <div
                                                onClick={(e) => {
                                                    if (item.home_card_state != 6) {
                                                        e.preventDefault()
                                                        e.stopPropagation()
                                                        setDelDialog(true)
                                                        setDeleteId(item.id)
                                                        setPromptText(t("agent.agent.delete_ai_agent_confirmation"))
                                                    } else {
                                                        setText(t("other.attention"))
                                                        setDialog(true)
                                                        setPromptText(t("agent.agent.card_in_mining"))
                                                    }
                                                }}
                                                className={`${item.mint_state == 3 ? 'hidden' : ''} bg-[#7F7F7F] w-6 h-6 z-[3] absolute top-[35px] right-[5px] flex rounded-full justify-center items-center`}>
                                                <svg width="14px" height="14px" viewBox="0 0 14 14" version="1.1" xmlns="http://www.w3.org/2000/svg"
                                                    xmlnsXlink="http://www.w3.org/1999/xlink">
                                                    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                                                        <g transform="translate(-161.000000, -107.000000)" fill="#FFFFFF" fillRule="nonzero">
                                                            <g transform="translate(156.000000, 102.000000)">
                                                                <g transform="translate(5.000000, 5.000000)">
                                                                    <path d="M10.7170812,1.99369951 C11.4120222,2.08457884 12.1351682,1.96761162 12.7026209,2.05730336 C13.6215884,2.20255845 14.08739,2.9286197 13.9864304,3.99746427 C13.6155535,3.99746427 13.2447185,3.99746427 12.8737788,3.99746427 C12.8424305,5.89352885 12.8567217,7.77246106 12.8567217,9.67483346 C12.8567217,10.6350239 12.9427825,11.6448397 12.8396226,12.5055457 C12.7420157,13.3192739 12.1004882,13.8148467 11.3161964,13.9368368 C10.542843,14.0571137 9.51658757,13.9686485 8.66310345,13.9686485 C6.87340614,13.9686485 5.05990432,14.0008495 3.30551566,13.9686485 C2.45113049,13.9529373 1.82167285,13.7010139 1.43977382,13.2211718 C1.05783287,12.7413686 1.09743722,12.0152684 1.09743722,11.1538226 C1.09743722,8.75385277 1.09743722,6.37405237 1.09743722,3.99746427 C0.743659365,3.99746427 0.389902439,3.99746427 0.036166501,3.99746427 C-0.136164787,3.01404784 0.322072158,2.30733835 1.09743722,2.0732092 C1.66738357,1.90106802 2.42722121,2.04011261 3.23701483,1.99369951 C3.17163623,0.935173298 3.23320108,0.131081959 4.21270665,0.0217269375 C4.65047087,-0.0271586719 5.23506453,0.0217269375 5.77030992,0.0217269375 C6.73539866,0.0217269375 7.85377088,0.0217269375 8.88562125,0.0217269375 C9.4796026,0.0217269375 10.087456,-0.0315391046 10.3919065,0.212557962 C10.8135356,0.550688294 10.7031463,1.32954833 10.7170812,1.99369951 Z M4.29822266,1.07131708 C4.29822266,1.38937528 4.29822266,1.7074335 4.29822266,2.0254917 C6.08408526,2.0254917 7.86994786,2.0254917 9.65578951,2.0254917 C9.65578951,1.69152765 9.65578951,1.35756363 9.65578951,1.02361906 C7.87566849,1.02361906 6.09546365,1.02361906 4.31532168,1.02361906 C4.29537283,1.02628626 4.29673489,1.04875299 4.29822266,1.07131708 Z M3.25409288,4.10878562 C3.25409288,6.12140859 3.25409288,8.12562113 3.25409288,10.1678169 C3.25409288,10.6853891 3.12601787,11.7881285 3.45949064,12.0125623 C3.59215472,12.1018646 3.93421892,12.1150449 4.0928249,12.0125623 C4.4378437,11.7897638 4.31534265,10.7184078 4.31534265,10.1837227 C4.31534265,8.11526384 4.31534265,6.01947108 4.31534265,4.06106812 C3.96732732,4.06106812 3.61924914,4.06106812 3.27121286,4.06106812 C3.251264,4.06373532 3.25260509,4.08620207 3.25409288,4.10878562 Z M6.43782122,4.10878562 C6.43782122,5.92060964 6.43782122,8.03629927 6.43782122,9.97698584 C6.43782122,10.4399682 6.32204662,11.5358741 6.52340014,11.8535429 C6.6564414,12.0634142 7.10418005,12.1585571 7.32789221,11.9966954 C7.63125311,11.7772066 7.49909194,10.6165871 7.49909194,10.1360441 C7.49909194,8.06234822 7.49909194,6.0731849 7.49909194,4.06110705 C7.15105566,4.06110705 6.80295652,4.06110705 6.45494118,4.06110705 C6.43499234,4.06373532 6.4363544,4.08620207 6.43782122,4.10878562 Z M9.65578951,4.10878562 C9.65578951,6.05881711 9.65578951,8.22944707 9.65578951,10.247346 C9.65578951,10.8760254 9.52387981,11.8403043 9.96388618,12.0125623 C10.1554748,12.0875942 10.4954855,12.0295583 10.5800795,11.9648837 C10.8673472,11.7451613 10.7341802,10.5671564 10.7341802,10.1042325 C10.7341802,8.04099121 10.7341802,6.06236037 10.7341802,4.06110707 C10.3804024,4.06110707 10.0266245,4.06110707 9.6729095,4.06110707 C9.65296063,4.06373532 9.65432269,4.08620207 9.65578951,4.10878562 Z"></path>
                                                                </g>
                                                            </g>
                                                        </g>
                                                    </g>
                                                </svg>
                                            </div>
                                            <div
                                                onClick={(e) => {
                                                    e.preventDefault()
                                                    e.stopPropagation()
                                                    navigate(`/edit-agents?type=edit&id=${item.id}`)
                                                }}
                                                className={`${item.mint_state == 3 ? 'top-[35px]' : 'top-[70px]'} bg-[#7F7F7F] w-6 h-6 z-[3]  right-[5px] absolute flex rounded-full justify-center items-center`}>
                                                <svg width="13px" height="14px" viewBox="0 0 13 14" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
                                                    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                                                        <g transform="translate(-161.000000, -136.000000)" fill="#FFFFFF" fillRule="nonzero">
                                                            <g transform="translate(156.000000, 131.000000)">
                                                                <g transform="translate(5.000000, 5.000000)">
                                                                    <path d="M3.8607819,12.2832205 L0,13 L0.778359243,9.18617349 L3.8607819,12.2832205 Z M9.91757734,0 L8.53393874,1.38957244 L11.6163614,4.48761919 L13,3.09804675 L9.91757734,0 Z M1.46967831,8.49138727 L4.55210097,11.589434 L10.9260428,5.18340511 L7.84362013,2.08435866 L1.46967831,8.49138727 Z" id="形状"></path>
                                                                    <path d="M5,12 L6.98955484,12 L6.98955484,14 L5,14 L5,12 Z M8.04700323,12 L10.0365581,12 L10.0365581,14 L8.04700323,14 L8.04700323,12 Z M11.0313355,12 L13,12 L13,14 L11.0313355,14 L11.0313355,12 Z" id="形状"></path>
                                                                </g>
                                                            </g>
                                                        </g>
                                                    </g>
                                                </svg>
                                            </div>
                                        </>}

                                    {
                                        type != 'mining' ?
                                            <Swiper indicator={true} style={{ borderRadius: "8px", position: "absolute" }} className='rounded-xl top-0 left-0' autoplay={((Math.random() * 0.4 + 0.15) * (i + 1000) * 45)}>
                                                {item?.main_images.map((image: any, ii: number) => (
                                                    <Swiper.Item onClick={(e: any) => {
                                                        e.stopPropagation()
                                                        // if (localStorage.getItem('token')) {
                                                        //     goToTalk(item)
                                                        // } else {
                                                        //     dispatch(changeLoginState(true))
                                                        // }
                                                        goToTalk(item)
                                                    }} key={ii} className='min-h-[269px] h-fit cursor-pointer w-[calc((100%)] rounded-xl'>
                                                        <img className='rounded-xl' src={`https://testton.starland.ai${image}`} alt="" />
                                                        {
                                                            !settings.star_nsfw && !item.is_my && item?.main_images_nsfw.length > 0 && item?.main_images_nsfw[ii] && <GlassmorphismCanvas
                                                                imageUrl={image}
                                                                x={0}
                                                                y={0}
                                                                width={swiperRef.current?.getBoundingClientRect().width || 188}
                                                                height={swiperRef.current?.getBoundingClientRect().height || 269}
                                                                blurRadius={40}
                                                                zIndex={0}
                                                                index={ii}
                                                            />
                                                        }
                                                        {
                                                            (!settings.star_nsfw) && item?.main_images_nsfw.length > 0 && item?.main_images_nsfw[ii] &&
                                                            <div className='w-[100%] cursor-pointer h-[100%] absolute top-0 left-0 flex items-center justify-center !backdrop-blur-[1.25rem] z-1'
                                                                onClick={(e: any) => {
                                                                    e.stopPropagation()
                                                                    // if (localStorage.getItem('token')) {
                                                                    //     goToTalk(item)
                                                                    // } else {
                                                                    //     dispatch(changeLoginState(true))
                                                                    // }
                                                                    goToTalk(item)
                                                                }}
                                                            >
                                                                <img onClick={(event) => {
                                                                    event.stopPropagation()
                                                                    if (localStorage.getItem('token')) {
                                                                        if (settings.character_nsfw) {
                                                                            setCharacterList(characterList.map((el: any, it: number) => {
                                                                                if (el.id == item.id) {
                                                                                    let obj = JSON.parse(JSON.stringify(el))
                                                                                    if (obj.main_images_nsfw[ii]) {
                                                                                        obj.main_images_nsfw[ii] = !obj.main_images_nsfw[ii]
                                                                                    }
                                                                                    return obj
                                                                                }
                                                                                return el;
                                                                            }))
                                                                        } else {
                                                                            setStateType({ character_nsfw: true })
                                                                            setCoin_NSFW(true)
                                                                        }
                                                                    } else {
                                                                        dispatch(changeLoginState(true))
                                                                    }
                                                                }} className='cursor-pointer' src={show} alt="" />
                                                            </div>
                                                        }
                                                    </Swiper.Item>
                                                ))}
                                            </Swiper> :
                                            <img
                                                className='cursor-pointer'
                                                onClick={() => {
                                                    callback && callback(item)
                                                }}
                                                src={item.url} alt="" />
                                    }
                                    {item.mint_state == 3 &&
                                        <>
                                            <img className=' absolute left-0 top-[0px] w-6 h-6' src={attributeImage(item.property)} alt="" />
                                            <img className=' absolute left-0 top-[29px] w-[42px] h-5' src={newNfted} alt="" />
                                        </>
                                    }
                                    {
                                        Array.isArray(cardArray) && cardArray?.some((e: any) => e?.id == item.id) &&
                                        <>
                                            <div className='absolute top-0 left-0 w-full h-full bg-[#000000] opacity-[0.5] z-[2]'></div>
                                            <img className='absolute  w-[85px] top-[45%] right-[50%] translate-x-[50%] z-[3] translate-y-[-50%]' src={miningSelect} alt="" />
                                        </>
                                    }
                                    {isActive == 3 && item.power != 0 &&
                                        <div className={` h-6 absolute px-[5px] flex items-center justify-center z-10 top-0 right-0`}>
                                            <div className=' absolute top-0 left-0 w-full h-full opacity-60' style={{ backgroundImage: `url(${power_bg})`, backgroundSize: '100% 100%' }}></div>
                                            <p className={`${item?.bonus_power ? 'text-style-4 pr-[2px]' : 'text-style-7'} !text-[12px] !font-bold`}>{item?.bonus_power ? item?.bonus_power + item?.power : item?.power}</p>
                                        </div>
                                    }
                                    <div className={`info ${type == 'mining' ? 'h-[64px]' : 'h-[100px]'} absolute bottom-0 px-3 py-2 box-border left-0 w-full  bg-gradient-to-t from-[#454545] to-[#000]/[0] rounded-r-xl rounded-l-xl`}>
                                        <div onClick={() => {
                                            if (localStorage.getItem('token')) {
                                                if (type == 'mining') {
                                                    callback && callback(item)
                                                } else {
                                                    goToTalk(item)
                                                }
                                            } else {
                                                dispatch(changeLoginState(true))
                                            }
                                        }} className="font-bold cursor-pointer text-base text-white">{item?.name}</div>
                                        <div onClick={() => {
                                            if (localStorage.getItem('token')) {
                                                if (type == 'mining') {
                                                    callback && callback(item)
                                                } else {
                                                    goToTalk(item)
                                                }
                                            } else {
                                                dispatch(changeLoginState(true))
                                            }
                                        }} className="options cursor-pointer w-full h-7 flex">
                                            {/*  点赞 */}
                                            <div className='flex items-center'>
                                                <svg width="12px" height="12px" viewBox="0 0 12 12" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">

                                                    <g id="页面-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                                                        <g id="02-talk平铺" transform="translate(-26.000000, -256.000000)" fill="#E0E0E0" fillRule="nonzero">
                                                            <g id="编组-12" transform="translate(16.000000, 213.000000)">
                                                                <g id="编组-11" transform="translate(10.000000, 41.000000)">
                                                                    <g id="编组备份-14" transform="translate(0.000000, 2.000000)">
                                                                        <path d="M8.21868721,0.0401908054 C9.22610184,-0.121578513 10.1720156,0.207559831 10.9376267,0.98125273 C11.715538,1.76770052 12.0884434,2.80395747 11.9822419,3.89092289 C11.8772403,4.96482233 11.3276324,6.02534468 10.4027189,6.96018472 C10.1447152,7.2211933 9.45110512,7.92582315 8.45569067,8.93812579 C8.00808417,9.39356865 7.53167724,9.87794334 7.05167028,10.3669844 L6.58486349,10.8417152 L6.3994608,11.0305498 C6.17760519,11.2564834 5.8221048,11.2564834 5.6002492,11.0305498 L3.98862579,9.38796894 L3.64812085,9.04203146 C2.9645117,8.34797578 2.28080177,7.65402686 1.59699106,6.96018472 C0.672077627,6.02534468 0.122769655,4.96513342 0.0177681253,3.89092289 C-0.0884334169,2.80395747 0.284171994,1.76770052 1.0623833,0.98125273 C1.82799442,0.207559831 2.77390816,-0.121267423 3.78132278,0.0401908054 C4.52893364,0.159962319 5.28734465,0.546031036 6.000155,1.16230993 C6.71326535,0.546342126 7.47137637,0.159962319 8.21898723,0.0401908054 L8.21868721,0.0401908054 Z" id="路径"></path>
                                                                    </g>
                                                                </g>
                                                            </g>
                                                        </g>
                                                    </g>
                                                </svg>
                                                <div className='ml-1 text-xs text-[#e0e0e0]'>{item?.like_count}</div>

                                            </div>
                                            {/* 交互 */}
                                            <div className='flex items-center ml-3'>
                                                <svg width="12px" height="12px" viewBox="0 0 12 12" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">

                                                    <g id="页面-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                                                        <g id="02-talk平铺" transform="translate(-64.000000, -255.000000)" fill="#E0E0E0" fillRule="nonzero">
                                                            <g id="编组-12" transform="translate(16.000000, 213.000000)">
                                                                <g id="编组-11" transform="translate(10.000000, 41.000000)">
                                                                    <g id="编组备份-13" transform="translate(38.000000, 1.000000)">
                                                                        <path d="M11.5239457,3.42134657 C11.2161611,2.7466612 10.7767079,2.1399395 10.2312596,1.63662729 C9.68247157,1.12220127 9.04171997,0.715207345 8.34233458,0.436816014 C6.84395033,-0.145605338 5.18103645,-0.145605338 3.6826522,0.436816014 C2.97615232,0.712982518 2.32842877,1.12008551 1.77368555,1.63662729 C1.23594722,2.14222152 0.803473534,2.74870995 0.501041122,3.42134657 C0.178294404,4.10860716 0.00741922747,4.85707272 0,5.61600137 C0.00821477146,6.99708519 0.546071031,8.32262114 1.50312335,9.3204187 L1.77368555,11.6250562 C1.79898275,11.8381332 1.97951517,11.9989627 2.19456009,12 C2.26829417,12.0001518 2.34080535,11.9812032 2.40499735,11.9450059 L4.14862044,10.9451631 C5.52973447,11.3649235 7.01226158,11.3085725 8.35736582,10.7851883 C9.06386569,10.5090218 9.71158924,10.1019188 10.2663325,9.58537702 C10.7970641,9.08283239 11.2242718,8.48166296 11.5239457,7.81565538 C12.1586848,6.41934278 12.1586848,4.81765917 11.5239457,3.42134657 Z M3.40707958,6.27089836 C3.05011418,6.27089836 2.76073656,5.98216743 2.76073656,5.62599979 C2.76073656,5.26983215 3.0501142,4.98110124 3.4070796,4.98110124 C3.764045,4.98110124 4.0534227,5.26983216 4.0534227,5.6259998 C4.05359058,5.97450211 3.77623622,6.26009212 3.42712123,6.27089836 L3.40707958,6.27089836 Z M5.99245174,6.27089836 C5.63548634,6.27089836 5.34610872,5.98216743 5.34610872,5.62599979 C5.34610872,5.26983215 5.63548636,4.98110124 5.99245176,4.98110124 C6.34941716,4.98110124 6.63879486,5.26983216 6.63879486,5.6259998 C6.63896274,5.97450211 6.36160838,6.26009212 6.01249339,6.27089836 L5.99245174,6.27089836 Z M8.5778239,6.27089836 C8.2208585,6.27089836 7.93148088,5.98216743 7.93148088,5.62599979 C7.93148088,5.26983215 8.22085852,4.98110124 8.57782391,4.98110124 C8.93478931,4.98110124 9.22416697,5.26983216 9.22416697,5.6259998 C9.22426192,5.97639176 8.94393696,6.26274972 8.59285513,6.27089836 L8.5778239,6.27089836 Z" id="形状"></path>
                                                                    </g>
                                                                </g>
                                                            </g>
                                                        </g>
                                                    </g>
                                                </svg>
                                                <div className='ml-1 text-xs text-[#e0e0e0]'>{item?.chat_count}</div>
                                            </div>
                                            {type != 'mining' && isActive === 3 && <div className='ml-3 !text-xs flex items-center text-style-6'><img src={coin} className='w-3 mr-1' alt="" />{FormattingNumber(item.profit.toString())} </div>}                                    </div>
                                        <Popover
                                            ref={popover}
                                            placement={i % 2 == 1 ? 'bottom-end' : 'bottom-start'}
                                            theme='dark'
                                            teleport={characterDom.current}
                                            reference={<div className='text-xs z-10 text-white h-8 line-clamp-2'>{item?.description}</div>}
                                        >
                                            <div style={{ textShadow: '0px 2px 4px rgba(0,0,0,0.5)' }} className='text-[14px] w-[285px] p-[10px] leading-[18px] text-[#ffffff]'>{item?.description}</div>
                                        </Popover>
                                    </div>

                                    {/* <img className={`${item.is_nsfw ? '' : 'hidden'} absolute z-[3] w-10`} src={nsfw} alt="" /> */}
                                </div >
                            )
                        })}
                        {
                            !isLoading && !characterList.length &&
                            <div className={'w-[100%] h-[calc(100vh_-_120px)] py-4 flex flex-col items-center'}>
                                <img className="w-[225px] mt-10" src={loading}></img>
                                <p className='text-[14px] text-[#FFF] mt-[25px] leading-[18px] font-bold'>{t("agent.agent.create_ai_agents")}</p>

                            </div>

                        }
                        {
                            isLoading && !characterList.length &&
                            <div className={'w-[100%]  py-4 flex flex-col items-center'}>
                                <Loading type="spinner" size="20" color="#00E49F">
                                    <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#00E49F] to-[#54ADFF]">{t("other.loading")}</span>
                                </Loading>
                            </div>

                        }

                    </List >
                }

                {
                    isActive == 4 && <Logs></Logs>

                }

                <div className={`${isActive == 4 || type == 'mining' ? 'hidden' : ''} md:absolute max-md:fixed fixed md:bottom-[10px] bottom-[130px] z-10 left-[50%] translate-x-[-50%]`}>
                    <ButtonComp children={
                        <svg width="14px" className='mr-1' height="14px" viewBox="0 0 14 14" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
                            <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                                <g transform="translate(-135.000000, -667.000000)">
                                    <g transform="translate(135.000000, 667.000000)">
                                        <rect fill="#D8D8D8" opacity="0" x="0" y="0" width="14" height="14"></rect>
                                        <g transform="translate(1.000000, 0.000000)" fill="#FFFFFF" fillRule="nonzero">
                                            <path d="M11.9335355,7.62303152 L11.0266453,5.59439713 L11.0266453,5.31988638 C11.0254568,3.85342934 10.4113386,2.45837032 9.3408964,1.49046152 C8.12276503,0.38103467 6.50602008,-0.147343163 4.88913236,0.035554589 C2.34717244,0.304575111 0.306669451,2.27556225 0.0319350571,4.72145297 C-0.15629891,6.41924835 0.495917588,8.10094747 1.76836309,9.19872317 C2.27529829,9.62937567 2.49898336,10.3199999 2.34450511,10.9775528 L1.81104028,13.0583442 C1.72488752,13.2987665 1.7556188,13.5670899 1.89372732,13.7803075 C2.000878,13.9209047 2.16556174,14.0020957 2.33917047,13.9999589 L7.31906467,13.9999589 C7.59639231,14.0003362 7.83788283,13.8051416 7.90320867,13.5277576 L8.23128954,12.0179485 C8.28211602,11.8483879 8.43780214,11.7355526 8.61004958,11.7434378 L9.91970574,11.7434378 C10.2082993,11.7500547 10.4875162,11.6378176 10.6953548,11.4316494 C10.9031935,11.2254812 11.0224509,10.9424465 11.0266453,10.6453948 L11.0266453,8.72381959 L11.2080233,8.72381959 C11.4799989,8.72549105 11.7341786,8.58487244 11.8828563,8.35048498 C12.0185278,8.13253687 12.0376072,7.85867002 11.9335355,7.62303152 L11.9335355,7.62303152 Z M5.69092202,3.56928969 C5.33883837,3.90472536 4.82767773,3.99494456 4.3871142,3.7994101 C4.32704015,3.77427737 4.25980524,3.77427737 4.19973119,3.7994101 C4.14630909,3.81970504 4.10351569,3.8619847 4.08163265,3.91609087 C3.95731633,4.16911992 3.76843262,4.38255881 3.5352301,4.53352661 C3.43429621,4.60252243 3.37483945,4.7200084 3.37776539,4.84467533 L3.37776539,5.09262197 C3.347185,5.33487788 3.14667748,5.51615845 2.90930787,5.51615845 C2.67193826,5.51615845 2.47143074,5.33487788 2.44085036,5.09262197 L2.44085036,4.79119665 C2.434816,4.65901247 2.36668014,4.53811108 2.25819128,4.46708339 C1.88125228,4.2043136 1.71669764,3.71799943 1.85350698,3.2711055 C2.08129498,2.56592024 2.59990525,2.00016247 3.27068939,1.7250853 C3.9083176,1.45517584 4.62210884,1.44647884 5.2657673,1.70077681 C5.69407131,1.86283344 5.98223173,2.18694668 6.05309085,2.55643579 C6.11226624,2.93595319 5.97502002,3.31978071 5.69092202,3.56928969 L5.69092202,3.56928969 Z" id="形状"></path>
                                        </g>
                                    </g>
                                </g>
                            </g>
                        </svg>
                    } title={t("agent.agent.create_agents")} callBack={() => {
                        localStorage.getItem('token') ? createAvatarsHandle() : dispatch(changeLoginState(true))
                    }}></ButtonComp>
                </div>
                {/* <HotRewardTaskDialog></HotRewardTaskDialog> */}
                <audio ref={closeAudioRef} src={closeMusic} id="audio"></audio>

                {
                    coin_NSFW && <NsfwPay type={15} closeHandle={async (val) => {
                        setCoin_NSFW(false)
                        if (!val) {
                            return;
                        }
                        try {
                            const result = await postSetting(localStorage.getItem('userId'), { ...settings, ...starType, order_id: val })
                            if (result.code == 0) {
                                dispatch(changeSettings({ ...settings, ...starType }))
                                setUserInfo()
                            } else {
                                setText(t("other.attention"))
                                setPromptText(t("other.neterror"))
                                setDialog(true)
                            }
                            let ID = window.localStorage.getItem("userId") || "";

                            const setting = await getSetting(ID)
                            if (setting.code == 0) {
                                dispatch(changeSettings(setting.data))
                            } else {
                                setText(t("other.attention"))
                                setPromptText(t("other.neterror"))
                                setDialog(true)
                            }
                        } catch {
                            setText(t("other.attention"))
                            setPromptText(t("other.neterror"))
                            setDialog(true)
                        }
                    }


                    }></NsfwPay>
                }
                <PromptDialog
                    title={t("other.attention")}
                    dialog={payDialog}
                    setDialog={setPayDialog}
                    text={`${t("agent.agent.paid_task_created_by")} @${payData?.account_name ? payData?.account_name : payData?.account_id}${t("agent.agent.one_time_fee_of")}  ${FormattingNumber(payData?.price.toString())} ${t("agent.agent.star_required")}`}
                    isClose={true}
                    callback={
                        postCommercial
                    }
                ></PromptDialog>
                <PromptDialog title={text} dialog={dialog} setDialog={setDialog} callback={() => { setDialog(false) }} text={promptText}></PromptDialog>
                <PromptDialog isClose={true} lineBreak={true} title={t("other.attention")} dialog={delDialog} setDialog={setDelDialog} callback={deleteAvatar} text={promptText}></PromptDialog>
                <PromptDialog isClose={true} title={t("other.attention")} dialog={spendCoins} setDialog={setSpendCoins} callback={() => {
                    createHandle()

                }} text={t("agent.agent.create_ai_agent_cost")}></PromptDialog>

                {/* {
                isShare && <ShareLog id={avatarID} sessionID={sessionID} charList={charList} callback={() => { setIsShare(false) }} type="list" ></ShareLog>
            } */}

                <Init tele={characterDom}></Init>
                {!guideTypeList.status && guideType && !guideTypeList.tasks.avatarGuide && <AgentsGuide></AgentsGuide>}
            </div >
        </div>
    )
}


export default Character;